import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractShapeComponent } from '../abstract-shape.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3Line]',
  templateUrl: './line.component.html',
  styleUrls: [
    '../line-shape-styles.scss',
    '../../shape-parts/outline-host.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LineComponent extends AbstractShapeComponent {}
